class FileHandleStore {
	constructor() {
		this._handlesByKey = new Map();
	}

	buildKey(fieldId, repeatId) {
		return `${fieldId}:${repeatId ?? "base"}`;
	}

	storeForKey(key, file) {
		if(!file) {
			return undefined;
		}

		const handle = this._buildHandle(file);
		const info = this._buildInfo(handle);

		this._handlesByKey.set(key, {
			file,
			handle,
			info,
			key,
			createdAt: Date.now()
		});

		return { handle, info };
	}

	getByKey(key) {
		return this._handlesByKey.get(key);
	}

	clearKey(key) {
		const entry = this._handlesByKey.get(key);
		if(entry?.handle?.$uri) {
			URL.revokeObjectURL(entry.handle.$uri);
		}
		this._handlesByKey.delete(key);
	}

	_buildHandle(file) {
		const objectUrl = URL.createObjectURL(file);
		return {
			id: undefined,
			name: file.name,
			length: file.size,
			mimeType: file.type,
			$uri: objectUrl
		};
	}

	_buildInfo(handle) {
		return {
			name: handle?.name
		};
	}
}

export default angular
	.module("vesl.services.file-handle-store", [])
	.service("fileHandleStore", FileHandleStore).name;
